export default class InitBookmark {
	brandTrigram: string | null

	constructor() {
		this.brandTrigram = document.body.getAttribute('data-brand-trigram')
	}

	init() {
		if (!this.brandTrigram) {
			console.warn('No brand trigram found in body attribute.')
			return
		}

		window.pmcstarter((pmc) => {
			const bookmark = new window.Bookmark({
				brand: pmc.config.trigram
			})

			bookmark.init()
		})
	}
}
